import { AlphaDBoxOutlineIcon } from './AlphaDBoxOutlineIcon';

/**
 * author: Contributors
 * id 5D512B06-6DF4-4BC7-A307-81512F828192
 * name alpha-d-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-d-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetDBoxOutlineIcon = AlphaDBoxOutlineIcon;
export default AlphabetDBoxOutlineIcon